import { RegionType, } from '@wix/shoutout-email-model-v3';
export function shouldShowAd(showAd, regions, experiments) {
    var _a;
    if (experiments['specs.so.public.EnableFooterAdForPremiums'] === 'true') {
        if (showAd === true) {
            return true;
        }
        else {
            var footerRegion = regions === null || regions === void 0 ? void 0 : regions.find(function (r) { return r.type === RegionType.Footer; });
            if (footerRegion) {
                return (_a = footerRegion.data.enabledWixBranding) !== null && _a !== void 0 ? _a : false;
            }
            return false;
        }
    }
    return showAd;
}
//# sourceMappingURL=show-ad.js.map